import {Drawer, DrawerSection} from '@logistics-frontend/blocks/legacy'
import React from 'react'

import DetailsList from './DetailsList'
import {classes as styles} from './styles'
import {Props} from './types'

const DetailsMobile: React.FC<Props> = ({onClose, classes, sections, title}) => {
  return (
    <Drawer onClose={onClose}>
      <DrawerSection fullHeight>
        <div className={styles.detailsMobile}>
          <div className={classes.title}>{title}</div>
          <DetailsList sections={sections} />
        </div>
      </DrawerSection>
    </Drawer>
  )
}

export default DetailsMobile
